/**
 * Query key factory.
 *
 * Every key lives here so that an invalidation site can never drift from the
 * query that produced the data. Keys are arrays whose first element names the
 * resource, matching the convention used in skyview-client.
 */
export const queryKeys = {
  config: () => ['config'] as const,
  versions: (apiId: string) => ['versions', apiId] as const,
  jiraReleases: (apiId: string) => ['jiraReleases', apiId] as const,
  users: () => ['users'] as const,
  subscribers: (status: string) => ['subscribers', status] as const,
  auditEntries: (month: string) => ['auditEntries', month] as const,
  errorCatalogues: () => ['errorCatalogues'] as const,
  errorCatalogue: (catalogueId: string) => ['errorCatalogue', catalogueId] as const,
  guides: (apiId: string) => ['guides', apiId] as const,
  guide: (apiId: string, guideId: string) => ['guide', apiId, guideId] as const,
};
